import { Grid, Stack } from "@mui/material";
import AuthRegister from "../../components/register/AuthRegister";
import AuthWrapper from "../../components/register/AuthWrapper";

const Logo = require("../../assets/images/logoTrixie.png");

function Register() {
  return (
    <AuthWrapper>
      <Grid
        container
        spacing={3}
        sx={{
          background: "linear-gradient(135deg, #202428, #2a323a, #37414d)",
          borderRadius: "24px",
          padding: "2rem",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.4)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        <Grid item xs={12} sx={{ padding: 0 }}>
          <Stack alignItems="center">
            <img
              src={Logo}
              alt="Logo Trixie"
              style={{
                maxWidth: "160px",
                marginBottom: "1rem",
                filter: "drop-shadow(0px 0px 6px rgba(255,255,255,0.15))",
              }}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{ padding: 0 }}>
          <AuthRegister />
        </Grid>
      </Grid>
    </AuthWrapper>
  );
}

export default Register;
